import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=24382b8e&scoped=true&"
import script from "./IntroPage.vue?vue&type=script&lang=js&"
export * from "./IntroPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroPage.vue?vue&type=style&index=0&id=24382b8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24382b8e",
  null
  
)

export default component.exports